export default __webpack_public_path__ + "static/media/g-3.9e7c0eae.jpg";